import React from 'react';
import language from '@language';
import './style.scss';

export default class Success extends React.Component<any> {
    constructor(props) {
        super(props);
    }

    render() {
        const { country, fields, originBank, destinationBank } = this.props;
        const isMarocco = country == 'MA';
        const today = new Date();

        return (
            <div>
                <div className="payment-details">
                    <div className="clock-box">
                        <p>
                            <i className="fa fa-clock-o" /> {language.make_transfer_disclaimer}
                        </p>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>{language.client_number}</td>
                                <td>{fields.client_number}</td>
                            </tr>
                            <tr>
                                <td>{language.property_name}</td>
                                <td>{fields.property_name}</td>
                            </tr>
                            <tr>
                                <td>{language.holder_name}</td>
                                <td>{fields.holder_name}</td>
                            </tr>
                            {!isMarocco && (
                                <tr>
                                    <td>{language.document}</td>
                                    <td>{fields.document}</td>
                                </tr>
                            )}
                            <tr>
                                <td>{language.email}</td>
                                <td>{fields.email}</td>
                            </tr>
                            <tr>
                                <td>{language.invoice_number}</td>
                                <td>{fields.invoice_number}</td>
                            </tr>
                            <tr>
                                <td>{language.amount}</td>
                                <td>${fields.amount}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="warning-box">
                        <p>
                            <i className="icon fa fa-exclamation-triangle" />
                            {language.important}
                        </p>
                        <p>{language.read_transfer_disclaimer_1}</p>
                        <p>{language.read_transfer_disclaimer_2}</p>
                        <p>
                            {language.read_transfer_disclaimer_3}
                        </p>
                    </div>
                </div>
                <div className="transfer-details">
                    <p className="title">{language.transfer_data}</p>
                    <div className="transfer-info">
                        <table>
                            <tbody>
                                <tr>
                                    <td>{language.reference}</td>
                                    <td>{destinationBank.reference}</td>
                                </tr>

                                <tr>
                                    <td>{language.bank}</td>
                                    <td>{destinationBank.bank_name}</td>
                                </tr>

                                <tr>
                                    <td>{isMarocco ? language.account_name : language.beneficiary}</td>
                                    <td>{destinationBank.beneficiary_name}%</td>
                                </tr>

                                {!isMarocco && [
                                    <tr key="1">
                                        <td>{destinationBank.beneficiary_document_type}</td>
                                        <td>{destinationBank.beneficiary_document}</td>
                                    </tr>,
                                    <tr key="2">
                                        <td>{language.account_type}</td>
                                        <td>{language.bank_transfer[destinationBank.bank_account_type.toLowerCase()]}</td>
                                    </tr> 
                                ]}
                                
                                <tr>
                                    <td>{destinationBank.bank_account_label}</td>
                                    <td>{destinationBank.bank_account}</td>
                                </tr>

                                {destinationBank.bank_account2_label && (
                                    <tr>
                                        <td>{destinationBank.bank_account2_label}</td>
                                        <td>{destinationBank.bank_account2}</td>
                                    </tr>
                                )}

                                {destinationBank.alias && (
                                    <tr>
                                        <td>{language.alias}</td>
                                        <td>{destinationBank.alias}</td>
                                    </tr>
                                )}
                                
                                <tr>
                                    <td>{language.amount_usd}</td>
                                    <td>${destinationBank.user_payment_amount}</td>
                                </tr>

                                {isMarocco && [
                                    <tr key="1">
                                        <td colSpan={2}><b>{language.important} : </b> {language.detect_message}</td><td></td>
                                    </tr>,
                                    <tr key="2">
                                        <td colSpan={2}>{fields.property_name} BOOKING {today.toLocaleDateString()}</td><td></td>
                                    </tr>
                                ]}
                            </tbody>
                        </table>
                    </div>
                   
                    <p>{destinationBank.beneficiary_name} {language.collect}</p>
                    
                    {originBank.link && (
                        <div className={`go-to-bank bank_${originBank.id}`}>
                            <a rel="noopener noreferrer" target="_blank" className="button" href={originBank.link}>
                                {language.make_transfer}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
